let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lDkFF")).then(() => parcelRequire('lsTfm'));